/* eslint-disable no-shadow */
import React, { useState, useEffect, useRef, useCallback } from 'react';

import { BiX } from 'react-icons/bi';

import parse from 'autosuggest-highlight/parse';

import debounce from 'lodash/debounce';

import * as Yup from 'yup';
import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';

import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import { Slide, useTheme } from '@material-ui/core';

import Autocomplete from '@material-ui/lab/Autocomplete';
import LocationOnIcon from '@material-ui/icons/LocationOn';

import Button from '../../../../newComponents/Button';
import UnformInput from '../../../../newComponents/UnformInput';

import stylesMaterial from './stylesMaterial';
import * as S from './styles';

import { googleLoader } from '../../../../utils/googleLoader';

import api from '../../../../services/api';

import { useAuth } from '../../../../hooks/auth';
import { useToast } from '../../../../hooks/toast';
import getValidationErrors from '../../../../utils/getValidationErrors';
import geographicApi, {
  IState,
  ICity,
} from '../../../../services/geographicApi';
import UnformSelect from '../../../../newComponents/UnformSelect';
import { maskCep } from '../../../../utils/mask';
import { ICustomer } from '../../../../interfaces/ICustomer';
import { IDeliveryAddress } from '../../../../interfaces/IDeliveryAddress';

interface ModalCreateAddressProps {
  selectedClient: ICustomer;
  isOpen: boolean;
  setModalCreateAddressIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setAddresses: React.Dispatch<React.SetStateAction<IDeliveryAddress[]>>;
}

export const ModalCreateAddress: React.FC<ModalCreateAddressProps> = (
  props,
) => {
  const {
    isOpen,
    selectedClient,
    setAddresses,
    setModalCreateAddressIsOpen,
  } = props;

  const formRefCreateAddress = useRef<FormHandles>(null);
  const map = useRef<google.maps.Map | null>(null);
  const marker = useRef<google.maps.Marker | null>(null);
  const circle = useRef<google.maps.Circle | null>(null);
  const infoWindow = useRef<google.maps.InfoWindow | null>(null);
  const geocoder = useRef<google.maps.Geocoder | null>(null);

  const classes = stylesMaterial();

  const { user } = useAuth();
  const { addToast } = useToast();
  const theme = useTheme();

  const isMainOption = [
    {
      id: 0,
      value: true,
      label: 'Sim',
    },
    {
      id: 1,
      value: false,
      label: 'Não',
    },
  ];

  const descriptionOption = [
    {
      id: 0,
      value: 'Casa',
      label: 'Casa',
    },
    {
      id: 1,
      value: 'Trabalho',
      label: 'Trabalho',
    },
    {
      id: 1,
      value: 'Outros',
      label: 'Outros',
    },
  ];

  const [step, setStep] = useState(0);
  const [
    companyLocation,
    setCompanyLocation,
  ] = useState<google.maps.LatLng | null>(null);
  const [
    value,
    setValue,
  ] = useState<google.maps.places.AutocompletePrediction | null>(null);
  const [inputValue, setInputValue] = useState('');
  const [options, setOptions] = useState<
    google.maps.places.AutocompletePrediction[]
  >([]);
  const [
    initialPlace,
    setInitialPlace,
  ] = useState<google.maps.GeocoderResult | null>(null);

  const [stateOptions, setStateOptions] = useState<IState[]>([
    {
      id: 21,
      sigla: 'MA',
      nome: 'Maranhão',
      regiao: {
        id: 2,
        sigla: 'NE',
        nome: 'Nordeste',
      },
    },
  ]);

  const [cityOptions, setCityOptions] = useState<ICity[]>([
    {
      id: 2111300,
      nome: 'São Luís',
      microrregiao: {
        id: 21002,
        nome: 'Aglomeração Urbana de São Luís',
        mesorregiao: {
          id: 2101,
          nome: 'Norte Maranhense',
          UF: {
            id: 21,
            sigla: 'MA',
            nome: 'Maranhão',
            regiao: {
              id: 2,
              sigla: 'NE',
              nome: 'Nordeste',
            },
          },
        },
      },
    },
  ]);

  const [selectedState, setSelectedState] = useState<IState | null>(null);
  const [selectedCity, setSelectedCity] = useState<ICity | null>(null);

  const [address, setAddress] = useState({
    complement: '',
    description: 'Casa',
    main: false,
    neighborhood: '',
    number: '',
    public_place: '',
    zip_code: '',
  });

  const [latLong, setLatLong] = useState<{ lat: number; long: number }>({
    lat: -2.535286,
    long: -44.22638,
  });
  const [lat, setLat] = useState(latLong.lat || undefined);
  const [lng, setLng] = useState(latLong.long || undefined);

  const service = useRef<google.maps.places.AutocompleteService | null>(null);

  const fetch = React.useMemo(
    () =>
      debounce(
        (
          request: {
            input: string;
            location: google.maps.LatLng | undefined;
          },
          callback: (
            results: google.maps.places.AutocompletePrediction[] | null,
            serviceStatus: google.maps.places.PlacesServiceStatus,
          ) => void,
        ) => {
          try {
            service.current?.getPlacePredictions(
              {
                componentRestrictions: { country: ['br'] },
                radius: 100000,
                ...request,
              },
              callback,
            );
          } catch (error) {
            console.log(error);
          }
        },
        1000,
      ),
    [],
  );

  function getLocationFromPlaceId(placeId: string): void {
    googleLoader.load().then(() => {
      geocoder.current = new google.maps.Geocoder();

      if (placeId) {
        geocoder.current.geocode({ placeId }, (res, status) => {
          if (status === 'OK') {
            if (res !== null) {
              setInitialPlace(res[0]);
            }
          }
        });
      } else {
        setInitialPlace(({
          address_components: [],
        } as unknown) as google.maps.GeocoderResult);
      }
    });
  }

  const useCurrentLocation = (): void => {
    googleLoader.load().then(() => {
      geocoder.current = new google.maps.Geocoder();

      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const pos = {
              lat: position.coords.latitude,
              lng: position.coords.longitude,
            };

            geocoder.current?.geocode({ location: pos }, (res, status) => {
              if (status === 'OK') {
                if (res !== null) {
                  setInitialPlace(res[0]);
                }
              }
            });
          },
          () => {
            addToast({
              type: 'info',
              title:
                'Ative a localização e dê permissão no navagador para usar',
            });
          },
        );
      } else {
        // Browser doesn't support Geolocations
        addToast({
          type: 'info',
          title: 'Ative a localização e dê permissão no navagador para usar',
        });
      }
    });
  };

  const validateFormAddress = useCallback(async (): Promise<void> => {
    const addressData = {
      ...address,
      city: selectedCity?.nome ?? '',
      state: selectedState?.nome ?? '',
    };

    try {
      formRefCreateAddress.current?.setErrors({});

      const schema = Yup.object().shape({
        city: Yup.string()
          .required('Infome a cidade para continuar')
          .min(1, 'Infome a cidade para continuar'),
        state: Yup.string()
          .required('Infome o estado para continuar')
          .min(1, 'Infome o Estado para continuar'),
        complement: Yup.string().notRequired(),
        description: Yup.string().required('Infome uma opção para continuar'),
        main: Yup.boolean().required('Informe uma opção para continuar.'),
        neighborhood: Yup.string().required('Infome o bairro para continuar'),
        number: Yup.string().notRequired(),
        public_place: Yup.string().required(
          'Infome o logradouro para continuar',
        ),
        zip_code: Yup.string()
          .required('Infome o CEP para continuar')
          .min(9, 'Mínimo de 9 caracteres'),
      });

      await schema.validate(addressData, { abortEarly: false });

      geographicApi
        .getLatLongV2(
          addressData.number,
          addressData.public_place,
          addressData.neighborhood,
          addressData.city,
          addressData.state,
        )
        .then((res) => {
          if (res.results[0]) {
            setLatLong({
              lat: Number(res.results[0].geometry.location.lat),
              long: Number(res.results[0].geometry.location.lng),
            });
            setStep(2);
          } else {
            geographicApi
              .getLatLongBairro(
                addressData.neighborhood,
                addressData.city,
                addressData.state,
              )
              .then((res) => {
                if (res.results[0]) {
                  setLatLong({
                    lat: Number(res.results[0].geometry.location.lat),
                    long: Number(res.results[0].geometry.location.lng),
                  });
                  setStep(2);
                } else {
                  geographicApi
                    .getLatLongCidade(addressData.city, addressData.state)
                    .then((res) => {
                      if (res.results[0]) {
                        setLatLong({
                          lat: Number(res.results[0].geometry.location.lat),
                          long: Number(res.results[0].geometry.location.lng),
                        });
                        setStep(2);
                      } else {
                        setStep(2);
                      }
                    })
                    .catch(() => {
                      setStep(2);
                    });
                }
              })
              .catch(() => {
                geographicApi
                  .getLatLongCidade(addressData.city, addressData.state)
                  .then((res) => {
                    if (res.results[0]) {
                      setLatLong({
                        lat: Number(res.results[0].geometry.location.lat),
                        long: Number(res.results[0].geometry.location.lng),
                      });
                      setStep(2);
                    } else {
                      setStep(2);
                    }
                  })
                  .catch(() => {
                    setStep(2);
                  });
              });
          }
        })
        .catch(() => {
          geographicApi
            .getLatLongBairro(
              addressData.neighborhood,
              addressData.city,
              addressData.state,
            )
            .then((res) => {
              if (res.results[0]) {
                setLatLong({
                  lat: Number(res.results[0].geometry.location.lat),
                  long: Number(res.results[0].geometry.location.lng),
                });
                setStep(2);
              } else {
                geographicApi
                  .getLatLongCidade(addressData.city, addressData.state)
                  .then((res) => {
                    if (res.results[0]) {
                      setLatLong({
                        lat: Number(res.results[0].geometry.location.lat),
                        long: Number(res.results[0].geometry.location.lng),
                      });
                      setStep(2);
                    } else {
                      setStep(2);
                    }
                  })
                  .catch(() => {
                    setStep(2);
                  });
              }
            })
            .catch(() => {
              geographicApi
                .getLatLongCidade(addressData.city, addressData.state)
                .then((res) => {
                  if (res.results[0].geometry.location.lat !== undefined) {
                    setLatLong({
                      lat: Number(res.results[0].geometry.location.lat),
                      long: Number(res.results[0].geometry.location.lng),
                    });
                    setStep(2);
                  } else {
                    setStep(2);
                  }
                })
                .catch(() => {
                  setStep(2);
                });
            });
        });
    } catch (error) {
      console.log(error);
      if (error instanceof Yup.ValidationError) {
        const errors = getValidationErrors(error);
        formRefCreateAddress.current?.setErrors(errors);
        return;
      }
      addToast({
        type: 'error',
        title: 'Erro no servidor',
      });
    }
  }, [addToast, address, selectedCity, selectedState]);

  const handleCreateAddress = async (): Promise<void> => {
    if (!selectedClient) {
      addToast({
        type: 'info',
        title: 'Selecione um cliente',
      });
    }

    try {
      const { data } = await api.post(
        `companies/${user.empresa_id}/delivery-addresses/customers`,
        {
          customerId: selectedClient.id,
          address: {
            bairro: address.neighborhood,
            cep: address.zip_code,
            cidade: selectedCity?.nome,
            complemento: address.complement,
            estado: selectedState?.nome,
            logradouro: address.public_place,
            numero: address.number,
          },
          latitude: lat,
          longitude: lng,
          isMain: address.main ? 1 : 0,
        },
      );

      setAddresses((oldState) => [...oldState, data]);

      addToast({
        type: 'success',
        title: 'Endereço criado',
      });

      setModalCreateAddressIsOpen(false);
    } catch (error) {
      addToast({
        type: 'error',
        title: 'Erro no servidor',
      });
    }
  };

  useEffect(() => {
    googleLoader.load().then(() => {
      service.current = new google.maps.places.AutocompleteService();
    });
  }, []);

  useEffect(() => {
    const loadLocation = async (): Promise<void> => {
      try {
        const { data } = await api.get(`/empresa/${user.empresa_id}`);

        if (data?.lat && data?.lon) {
          googleLoader.load().then(() => {
            const location = new google.maps.LatLng(data.lat, data.lon);
            setCompanyLocation(location);
          });
        }
      } catch (error) {
        addToast({
          type: 'error',
          title: 'Erro ao buscar localização da empresa.',
        });
      }
    };

    loadLocation();
  }, [addToast, user.empresa_id]);

  useEffect(() => {
    if (initialPlace) {
      setStep(1);
      const { address_components } = initialPlace;

      const newAddress = {
        neighborhood:
          address_components.find((item) =>
            item.types.includes('sublocality_level_1'),
          )?.long_name || '',
        public_place:
          address_components.find((item) => item.types.includes('route'))
            ?.long_name || '',
        zip_code:
          address_components.find((item) => item.types.includes('postal_code'))
            ?.long_name || '',
      };

      setAddress((oldState) => ({ ...oldState, ...newAddress }));

      const state =
        address_components.find((item) =>
          item.types.includes('administrative_area_level_1'),
        )?.long_name || '';

      state &&
        setSelectedState(
          stateOptions.find((opt) => opt.nome === state) ?? null,
        );
    }
  }, [initialPlace, stateOptions]);

  useEffect(() => {
    const fetch = async (): Promise<void> => {
      try {
        const response = await geographicApi.getEstados();
        setStateOptions(
          response.sort((a, b) => {
            if (a.nome > b.nome) return 1;
            if (a.nome < b.nome) return -1;
            return 0;
          }),
        );
      } catch (error) {
        console.log(error);
        addToast({
          type: 'error',
          title: 'Erro ao buscar os estados',
        });
      }
    };

    fetch();
  }, [addToast]);

  useEffect(() => {
    if (selectedState) {
      const fetch = async (): Promise<void> => {
        try {
          const response = await geographicApi.getCidades(
            selectedState.id.toString(),
          );
          setCityOptions(response);

          if (!initialPlace) return;

          const { address_components } = initialPlace;

          const city =
            address_components.find((item) =>
              item.types.includes('administrative_area_level_2'),
            )?.long_name || '';

          city &&
            setSelectedCity(response.find((opt) => opt.nome === city) ?? null);
        } catch (error) {
          console.log(error);
          addToast({
            type: 'error',
            title: 'Erro ao buscar cidades',
          });
        }
      };

      fetch();
    }
  }, [addToast, initialPlace, selectedState]);

  useEffect(() => {
    if (inputValue === '') {
      setOptions(value ? [value] : []);
      return;
    }

    fetch(
      { input: inputValue, location: companyLocation ?? undefined },
      (results: google.maps.places.AutocompletePrediction[] | null) => {
        let newOptions = [] as google.maps.places.AutocompletePrediction[];
        const notFoundOption = ({
          structured_formatting: {
            main_text_matched_substrings: [{ length: 26, offset: 0 }],
            main_text: 'Não encontrei meu endereço',
            secondary_text: '',
          },
          description: '',
        } as unknown) as google.maps.places.AutocompletePrediction;

        if (value) {
          newOptions = [value];
        }

        if (results) {
          newOptions = [...newOptions, ...results, notFoundOption];
        }

        setOptions(newOptions);
      },
    );
  }, [value, inputValue, fetch, user.empresa_id, companyLocation]);

  useEffect(() => {
    googleLoader.load().then(() => {
      const acceptedRadius = 500;

      const myLatlng = new google.maps.LatLng(latLong.lat, latLong.long);

      const mapDiv = document.getElementById('map-create-address');

      if (!mapDiv) return;

      map.current = new google.maps.Map(mapDiv, {
        center: myLatlng,
        zoom: 15,
      });

      marker.current = new google.maps.Marker({
        position: myLatlng,
        map: map.current,
        draggable: true,
        title: 'Localização',
      });

      circle.current = new google.maps.Circle({
        strokeColor: '#329BFC',
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: '#329BFC',
        fillOpacity: 0.35,
        map: map.current,
        center: myLatlng,
        radius: acceptedRadius,
      });

      infoWindow.current = new google.maps.InfoWindow();

      geocoder.current = new google.maps.Geocoder();

      let markerPosition: google.maps.LatLng | null;

      if (
        marker.current?.getPosition()?.lat() &&
        marker.current?.getPosition()?.lng()
      ) {
        setLat(marker.current?.getPosition()?.lat());
        setLng(marker.current?.getPosition()?.lng());
      }

      marker.current.addListener('dragstart', () => {
        markerPosition = marker.current?.getPosition() ?? null;
      });

      marker.current.addListener('dragend', () => {
        const position = marker.current?.getPosition();
        if (position) {
          const distance = google.maps.geometry.spherical.computeDistanceBetween(
            myLatlng,
            position,
          );
          if (distance > acceptedRadius) {
            marker.current?.setPosition(markerPosition);
          } else {
            setLat(marker.current?.getPosition()?.lat());
            setLng(marker.current?.getPosition()?.lng());
          }
        }
      });
    });
  }, [latLong]);

  return (
    <S.CustomModal
      open={isOpen}
      onClose={() => setModalCreateAddressIsOpen(false)}
      closeAfterTransition
    >
      <Slide direction="down" in={isOpen} mountOnEnter unmountOnExit>
        <div className="body">
          <S.ModalHeader>
            <h1>Criação de endereço</h1>
            <button
              type="button"
              onClick={() => setModalCreateAddressIsOpen(false)}
            >
              <BiX />
            </button>
          </S.ModalHeader>

          <S.ModalBody>
            {step === 0 ? (
              <div className="google-automcomplete">
                <Autocomplete
                  getOptionLabel={(option) =>
                    typeof option === 'string' ? option : option.description
                  }
                  noOptionsText="Sem endereço"
                  forcePopupIcon={false}
                  filterOptions={(x) => x}
                  options={options}
                  autoComplete
                  includeInputInList
                  filterSelectedOptions
                  value={value}
                  onChange={(
                    _: any,
                    newValue: google.maps.places.AutocompletePrediction | null,
                  ) => {
                    setOptions(newValue ? [newValue, ...options] : options);
                    setValue(newValue);

                    if (newValue) {
                      getLocationFromPlaceId(newValue.place_id);
                    }
                  }}
                  onInputChange={(_, newInputValue) => {
                    setInputValue(newInputValue);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      size="small"
                      label="Busque seu endereço"
                      variant="outlined"
                      fullWidth
                    />
                  )}
                  renderOption={(option) => {
                    const matches =
                      option.structured_formatting.main_text_matched_substrings;
                    const parts = parse(
                      option.structured_formatting.main_text,
                      matches && matches.length
                        ? matches.map((match: any) => [
                            match.offset,
                            match.offset + match.length,
                          ])
                        : [[0, 0]],
                    );

                    return (
                      <Grid container alignItems="center">
                        <Grid item>
                          <LocationOnIcon
                            style={{
                              color: option.place_id ? 'inherit' : 'red',
                            }}
                            className={classes.icon}
                          />
                        </Grid>
                        <Grid item xs>
                          {parts.map((part, index) => (
                            <span
                              key={index}
                              style={{ fontWeight: part.highlight ? 700 : 400 }}
                            >
                              {part.text}
                            </span>
                          ))}
                          <Typography variant="body2" color="textSecondary">
                            {option.structured_formatting.secondary_text}
                          </Typography>
                        </Grid>
                      </Grid>
                    );
                  }}
                />

                <Button onClick={useCurrentLocation}>
                  <LocationOnIcon />
                  Usar localização
                </Button>
              </div>
            ) : (
              <div />
            )}

            {step === 1 ? (
              <Form ref={formRefCreateAddress} onSubmit={() => null}>
                <div className="formulary">
                  <UnformInput
                    name="zip_code"
                    label="CEP *"
                    placeholder="Ex.: 12345-678"
                    value={address.zip_code}
                    onChange={(e) => {
                      e.preventDefault();
                      const newValue = e.target.value;

                      if (newValue.length > 9) return;

                      setAddress((oldState) => ({
                        ...oldState,
                        zip_code: maskCep(newValue),
                      }));
                    }}
                  />
                  <UnformInput
                    name="public_place"
                    label="Logradouro *"
                    placeholder="Rua/Avenida"
                    value={address.public_place}
                    onChange={(e) => {
                      e.preventDefault();
                      const newValue = e.target.value;

                      setAddress((oldState) => ({
                        ...oldState,
                        public_place: newValue,
                      }));
                    }}
                  />
                  <UnformInput
                    name="number"
                    label="Número"
                    placeholder="Ex.: 123"
                    value={address.number}
                    onChange={(e) => {
                      e.preventDefault();
                      const newValue = e.target.value;

                      setAddress((oldState) => ({
                        ...oldState,
                        number: newValue,
                      }));
                    }}
                  />
                  <UnformInput
                    name="neighborhood"
                    label="Bairro *"
                    placeholder="Ex.: Copacabana"
                    value={address.neighborhood}
                    onChange={(e) => {
                      e.preventDefault();
                      const newValue = e.target.value;

                      setAddress((oldState) => ({
                        ...oldState,
                        neighborhood: newValue,
                      }));
                    }}
                  />
                  <UnformInput
                    name="complement"
                    label="Complemento"
                    value={address.complement}
                    onChange={(e) => {
                      e.preventDefault();
                      const newValue = e.target.value;

                      setAddress((oldState) => ({
                        ...oldState,
                        complement: newValue,
                      }));
                    }}
                  />
                  <UnformSelect
                    name="state"
                    label="Estado *"
                    placeholder="Distrito Federal"
                    isClearable
                    options={stateOptions.map((opt) => ({
                      id: opt.id,
                      value: opt.nome,
                      label: opt.nome,
                    }))}
                    value={
                      selectedState
                        ? {
                            id: selectedState.id,
                            value: selectedState?.nome,
                            label: selectedState?.nome,
                          }
                        : undefined
                    }
                    onChange={(e) => {
                      if (!e) {
                        setSelectedState(null);
                        return;
                      }
                      setSelectedState(
                        stateOptions.find((opt) => opt.id === (e as any).id) ??
                          null,
                      );
                    }}
                  />
                  <UnformSelect
                    name="city"
                    label="Cidade *"
                    placeholder="Brasilia"
                    isClearable
                    options={cityOptions.map((opt) => ({
                      id: opt.id,
                      value: opt.nome,
                      label: opt.nome,
                    }))}
                    value={
                      selectedCity
                        ? {
                            id: selectedCity.id,
                            value: selectedCity?.nome,
                            label: selectedCity?.nome,
                          }
                        : undefined
                    }
                    onChange={(e) => {
                      if (!e) {
                        setSelectedCity(null);
                        return;
                      }
                      setSelectedCity(
                        cityOptions.find((opt) => opt.id === (e as any).id) ??
                          null,
                      );
                    }}
                  />
                  <UnformSelect
                    name="main"
                    label="Principal *"
                    options={isMainOption}
                    value={address.main ? isMainOption[0] : isMainOption[1]}
                    onChange={(e) => {
                      setAddress((oldState) => ({
                        ...oldState,
                        main: (e as any).value,
                      }));
                    }}
                  />
                  <UnformSelect
                    name="description"
                    label="Descrição *"
                    options={descriptionOption}
                    value={
                      descriptionOption.find(
                        (opt) => opt.value === address.description,
                      ) ?? descriptionOption[0]
                    }
                    onChange={(e) => {
                      setAddress((oldState) => ({
                        ...oldState,
                        description: (e as any).value,
                      }));
                    }}
                  />
                </div>
                <div className="buttons">
                  <Button type="button" onClick={validateFormAddress} full>
                    Avançar
                  </Button>
                  <Button
                    type="button"
                    variant="outlined"
                    onClick={() => setStep(0)}
                    full
                  >
                    Voltar
                  </Button>
                </div>
              </Form>
            ) : (
              <div />
            )}

            {step === 2 ? (
              <div className="map">
                <h2>Mova o marcador para o endereço antes de confirmar:</h2>

                <div id="map-create-address" />

                <div className="buttons">
                  <Button onClick={handleCreateAddress} full>
                    Finalizar
                  </Button>
                  <Button
                    type="button"
                    variant="outlined"
                    onClick={() => setStep(1)}
                    full
                  >
                    Voltar
                  </Button>
                </div>
              </div>
            ) : (
              <div />
            )}
          </S.ModalBody>
        </div>
      </Slide>
    </S.CustomModal>
  );
};
